module.exports = __webpack_public_path__ + "img/garantia-total.c862b166.png";